module.exports = __webpack_public_path__ + "233444b840f7d61423a1af86726dc9a8.png";